
import Vue from "vue";
import IbanDataCheck from "@/@modules/fseg/modals/ibanEdit/IbanDataCheck.vue";
import IbanForm from "@/@modules/fseg/modals/ibanEdit/IbanForm.vue";

export default Vue.extend({
  components: {
    IbanDataCheck,
    IbanForm,
  },
  props: {
    hasToDeleteIban: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      desktopSize: true,
      hasToCheckIbanData: false,
      ibanForm: {
        iban: "",
        bic: "",
      },
    };
  },
  created() {
    this.desktopSize = window.innerWidth > 480;
    this.hasToCheckIbanData = this.hasToDeleteIban;
  },
  methods: {
    continueIbanEdit(ibanForm: { iban: string; bic: string }) {
      this.ibanForm = ibanForm;
      this.hasToCheckIbanData = true;
    },
  },
});
